import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getWorkspaceTokens } from './workspaceStyles';

function AnalyticsWorkspaceBody({
  children,
  enabled = true,
  density = 'comfortable',
  scroll = 'content',
  sx,
  style,
}) {
  const theme = useTheme();
  const tokens = getWorkspaceTokens(theme);

  if (!enabled) return <>{children}</>;

  const densityStyles = density === 'compact'
    ? {
      gap: tokens.gap.compact,
      px: tokens.outerInset.compact,
      py: tokens.gutter.compact,
    }
    : {
      gap: tokens.gap.comfortable,
      px: tokens.outerInset.comfortable,
      py: tokens.gutter.comfortable,
    };

  return (
    <Box
      data-testid="analytics-workspace-body"
      style={style}
      sx={{
        width: '100%',
        maxWidth: tokens.contentMaxWidth,
        boxSizing: 'border-box',
        minWidth: 0,
        minHeight: 0,
        height: '100%',
        maxHeight: '100%',
        flex: '1 1 0',
        alignSelf: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: densityStyles.gap,
        px: densityStyles.px,
        py: densityStyles.py,
        overflowX: 'hidden',
        overflowY: scroll === 'page'
          ? 'visible'
          : scroll === 'panel'
            ? { xs: 'auto', md: 'hidden' }
            : 'auto',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default AnalyticsWorkspaceBody;
